// @flow weak

// #region imports

import { render } from 'react-dom';
import React, {  Component  } from 'react';
import PropTypes              from 'prop-types';
import { 
  Header,
  // Footer,
  AsideLeft,
  AsideRight
}                             from '../../components';
// import AsideLeftNew           from '../../components/aside/asideLeftNew';
import { Modals }             from '../../views';
import { appConfig }          from '../../config';
import { navigation }         from '../../models';
import MainRoutes             from '../../routes/MainRoutes';
import auth                   from '../../services/auth';
import UserIMG                from '../../img/user.jpg';
import { userActions } from '../../redux/actions/user';
import { sideMenuActions } from '../../redux/actions/sideMenu';
import {
  bindActionCreators,
  compose
}                               from 'redux';
import { withRouter }           from 'react-router';
import { connect }              from 'react-redux';
import { authHeader } from '../../_helpers/auth-header'; 
import Login                    from '../../views/login';
import Authorization from '../../routes/Authorization';
// #endregion

const MINUTES_UNITL_AUTO_LOGOUT = 1 // in mins
const CHECK_INTERVAL = 15000 // in ms
const STORE_KEY =  'lastAction';

class App extends Component {
  constructor(props){
    super(props);
    //this.check();
    //this.initListener();
    //this.initInterval();
  }

  static propTypes = {
    // react-router 4
    sideMenuIsCollapsed: PropTypes.bool,
    user:  PropTypes.shape({
      login:       PropTypes.string,
      firstname:   PropTypes.string,
      lastname:    PropTypes.string
      // picture:     PropTypes.string,
      // showPicture: PropTypes.bool
    }),
    // userInfos:  PropTypes.shape({
    //   login:       PropTypes.string,
    //   firstname:   PropTypes.string,
    //   lastname:    PropTypes.string,
    //   picture:     PropTypes.string,
    //   showPicture: PropTypes.bool
    // }),
    userIsConnected: PropTypes.bool,
    currentView:     PropTypes.string,

    actions: PropTypes.shape({
      enterHome: PropTypes.func,
      leaveHome: PropTypes.func,
      fetchEarningGraphDataIfNeeded: PropTypes.func,
      getUserRequest: PropTypes.func,
      openSideMenu:   PropTypes.func,
      closeSideMenu:  PropTypes.func,
      toggleSideMenu: PropTypes.func
    })
  };

  state = {
    appName:          appConfig.appName,
    connectionStatus: appConfig.connectionStatus,
    helloWord:        appConfig.helloWord,
    isAuthenticated:  false,
    isLoading:        true,
    currentView:      appConfig.currentView
  };

 

  // componentWillReceiveProps(nextProps){
  //   //console.log(nextProps.loginResponse.result.token,"login")
  //   if(nextProps.loginResponse){
  //     console.log(nextProps.loginResponse)
  //       if(nextProps.loginResponse.status === "success"){
  //           this.setState({login_token:nextProps.loginResponse.result.token})

  //           console.log(nextProps.loginResponse.result.token,"login");
  //           this.props.history.push('/home');
  //       }
  //       else {
  //           console.log("unknown error");
  //           alert('unknown error');
  //       }
  //   }
  // }
  // #region lifecycle methods
  componentDidMount() {

    const token= auth.getToken();
    //console.log('tokennoew');
    //console.log(token);


    try{
      if(token !== ''){
        this.setState({isAuthenticated: true, isLoading: false});
      }
      else {
        this.setState({isAuthenticated: false, isLoading: false});
      }
    }
    catch(error){
      this.setState({isLoading: false});
      alert('You are not authenticated for login!');
  }
   
  //getUserRequest();
    // const userdata=getUserRequest();
    // console.log('userdata');
    // console.log(userdata)
    // getSideMenuCollpasedStateFromLocalStorage();
  }

  getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
 
  setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }
 
  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover',()=> this.reset());
    document.body.addEventListener('mouseout',() => this.reset());
    document.body.addEventListener('keydown',() => this.reset());
    document.body.addEventListener('keyup',() => this.reset());
    document.body.addEventListener('keypress',() => this.reset());
  }
 
  reset() {
    this.setLastAction(Date.now());
  }
 
  initInterval() {
    //console.log('time checking1 ',this.check());
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }
 
  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;
    if (isTimeout) {

      if(this.state.isAuthenticated===true){
        // Call here logout function, expire session
       // console.log('time checking ',diff , timeleft);
        localStorage.clear();
         this.props.history.push("/");
         location.reload();
      }
    }
  }
 
  render() {
    const { isAuthenticated, isLoading } = this.state;
    const userinfo = auth.getUserInfo();
    if( !userinfo )
    {
      this.props.history.push("/");
      location.reload();
    }

    const { user, userIsConnected, sideMenuIsCollapsed, currentView } = this.props;
    const { appName, connectionStatus, helloWord } = this.state;

    const userFullName = `${userinfo.firstName} ${userinfo.lastName.toUpperCase()}`;
    //console.log('mainNavigation', navigation.mainNavigation[userinfo.userTypeName]);
      return (
        <div>
          {alert.message &&
            <div className={`alert ${alert.type}`}>{alert.message}</div>
          }
          <Header
            appName={appName}
            //userLogin={userInfos.login}
            userFirstname={userinfo.firstName}
            userLastname={userinfo.lastName}
            //userPicture={UserIMG}
            //showPicture={userInfos.showPicture}
            currentView={currentView}
            toggleSideMenu={this.handlesMenuButtonClick}
           
          />
          <div className="wrapper row-offcanvas row-offcanvas-left">
            <AsideLeft
              isAnimated={true}
              mainNavigation={navigation.mainNavigation[userinfo.userTypeName]}
              currentView={currentView}
              isCollapsed={sideMenuIsCollapsed}
              helloWord={helloWord}
              connectionStatus={connectionStatus}
              // userIsConnected={userIsConnected}
              userIsConnected={userinfo.status}
              username={userinfo.userName}
              usertype={userinfo.userTypeName}
              onLogout={this.handlesOnLogout}
              //userPicture={userInfos.picture}
              //showPicture={userInfos.showPicture}
            />
            {/*<AsideLeftNew
              userIsConnected={userinfo.status}
              username={userinfo.userName}
              usertype={userinfo.userTypeName}
              onLogout={this.handlesOnLogout}
            />*/}
            <AsideRight
              isAnimated={true}
              isExpanded={sideMenuIsCollapsed}>
              <MainRoutes />
            </AsideRight>
          </div>
          {/* <Footer /> */}
          {/* modals cannot be placed anywhere (avoid backdrop or modal placement issues) so all grouped in same component and outside .wrapper*/}
          <Modals />
        </div>
      );
  
   
  }
  
  // #endregion

  handlesMenuButtonClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    const { actions: { toggleSideMenu } } = this.props;
    toggleSideMenu();
  }

  handlesOnLogout =async (
    event: SyntheticEvent<>
  ) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    const { dispatch } = this.props;
 
    try{
      
      //dispatch(userActions.logout());
      const { actions: { logout } } = this.props;
      logout();
      auth.clearAllAppStorage();
      auth.clearToken();
    }
    catch(error){
      //console.log('something went wrong..., error: ', error);
    }
    
    // redirect to login
   // const { history } = this.props;
    //history.push('/');
  }
}
// function mapStateToProps(state) {
//   const { users, authentication, alert } = state;
//   //const { user } = authentication;
//   return {
//       alert,
//       user: state.user.data,
//       users
//   };
// }


// export default compose(
//   withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
//   connect(mapStateToProps)
// )(App);
//const connectedApp = connect(mapStateToProps)(App);
//export { connectedApp as App };
export default App;



// WEBPACK FOOTER //
// ./src/app/containers/app/App.js